(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("appversion", {
            parent: "app",
            url: "/appversion",
            data: {
                authorities: ["bilioslo-admin"],
            },
            views: {
                "content@": {
                    templateUrl: "app/appversion/appversion.html",
                    controller: "AppversionController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
